<template>
  <div>
    <Top/>
    <div class="cght_htmainbox">
      <div class="cght_htmain cgw1216">
         <!--左侧导航开始-->
        <div class="cght_htmainleft">
          <LeftNav :leftNavi='16'/>
        </div>
        <!--左侧导航完成-->
        <div class="cght_htmainright">
          <el-button type="primary" size="mini" round plain @click="Createtask()">创建任务</el-button>
          <el-date-picker
            v-model="addtimeBTTime"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            @change="selectOperationTime"
            size="small"
            style="margin-left: 50px;"
          >
          </el-date-picker>
          <el-select v-if="current_user.id == 2 || current_user.id == 100" v-model="listQuery.admin_id" placeholder="用户" clearable @change="selectOperationTime" size="small" style="width: 150px">
            <el-option
              v-for="item in optionsUserList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
          <!-- <div style="display: inline-block;padding-top:5px;padding-left:255px;">
            <i class="el-icon-question" style="font-size:15px;color:#436aa6;" @click="operationManual"></i>
          </div> -->
          <div class="cght_subpagemaina">
            <!--右边内容区域开始-->
            <el-row style="position: static;">
              <el-col :span="24" class="task">
                <el-table :data="list" v-loading="qyloading" border style="width: 100%">
                  <el-table-column align="center" prop="name" label="姓名" width="150px"></el-table-column>
                  <el-table-column align="center" prop="job_content" label="工作内容" show-overflow-tooltip width="200"></el-table-column>
                  <el-table-column align="center" prop="remark" label="备注" show-overflow-tooltip width="200"></el-table-column>
                  <el-table-column align="center" label="是否完成" width="200">
                    <template slot-scope="{row}">
                      <el-switch
                        style="display: block"
                        v-model="row.state"
                        active-value="1"
                        inactive-value="0"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        @change="changeinvoice(row)"
                        active-text="已完成"
                        inactive-text="未完成">
                      </el-switch>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" prop="tracking_number" label="物流单号" width="200px">
                    <template slot-scope="{row}">
                      <span @click="checkLogistics(row)" style="cursor: pointer; color: cornflowerblue;">{{ row.tracking_number }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" prop="date_time" label="日期" sortable width="150px"></el-table-column>
                  <el-table-column label="操作" align="center" fixed="right" width="120px">
                    <template slot-scope="scopes">
                      <el-button size="mini" type="text" @click="handleEdit(scopes.$index, scopes.row)">编辑</el-button>
                      <el-popover
                        :ref="`popover-${scopes.$index}`"
                        placement="top"
                        width="160"
                        trigger="click"
                      >
                        <p>确定删除该产品吗？</p>
                        <div style="text-align: right; margin: 0">
                          <el-button size="mini" type="text" @click="scopes._self.$refs[`popover-${scopes.$index}`].doClose()">取消</el-button>
                          <el-button type="primary" size="mini" @click="handleDelete(scopes.row,scopes.$index,scopes)">确定</el-button>
                        </div>
                        <el-button slot="reference" size="mini" type="text">删除</el-button>
                      </el-popover>
                      <el-popover
                        placement="right"
                        width="400"
                        trigger="click">
                        <ul>
                          <li v-show="scopes.row.imglist" v-for="(items,i) in scopes.row.imglist" :key="i+'fdsf'" style="padding: 8px 15px 8px;">
                            <span>{{ items }}</span>
                            <el-button type="primary" plain size="mini" style="float: right;" @click="dowloadFile(items)">预览</el-button>
                          </li>
                          <li v-show="scopes.row.voucher" v-for="(item,index) in scopes.row.voucher" :key="index" style="padding: 8px 15px 8px;">
                            <span>{{ item.name }}</span>
                            <el-button type="primary" plain size="mini" style="float: right;" @click="dowloadFiless(item.response)">预览</el-button>
                          </li>
                        </ul>
                        <el-button v-show="scopes.row.voucher || scopes.row.img" slot="reference" size="mini" type="text">凭证文件</el-button>
                      </el-popover>
                      <!-- <el-button slot="reference" v-show="scopes.row.img" size="mini" type="text" @click="handleClick(scopes.row)">文件预览</el-button> -->
                    </template>
                  </el-table-column>
                </el-table>
                <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="LoadData" />
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <Bottom/>
    <el-dialog title="日志信息" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-row>
          <el-col :span="22">
            <el-form-item label="姓名" prop="name">
              <el-input v-model="form.name" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="工作内容" prop="job_content">
              <el-input v-model="form.job_content" type="textarea" :rows="5"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="工作时间" required prop="date_time">
              <el-date-picker type="date" placeholder="选择日期" v-model="form.date_time" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="是否完成" required>
              <el-radio-group v-model="form.state" size="mini">
                <el-radio-button label="1">已完成</el-radio-button>
                <el-radio-button label="0">未完成</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="快递选择">
              <el-select v-model="form.expressage" clearable placeholder="请选择快递" style="width:330px">
                <el-option v-for="(items,index) in gridData" :key="index" :label="items" :value="items"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="订单号码">
              <el-input v-model="form.tracking_number"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="form.expressage === 'SF'">
          <el-col :span="11">
            <el-form-item label="手机号码">
              <el-input v-model="form.tel" placeholder="请输入收/寄件人手机号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="上传文件" prop="img">
              <el-upload
                ref="upload"
                class="upload-demo"
                :action="upload_url"
                :on-success="handlesuccess"
                :on-remove="removeUpload"
                :before-upload="beforeAvatarUpload"
                accept=".xls,.xlsx,.docx,.doc,.jpg,.png,.pdf,.zip,.rar"
                :file-list="fileList"
                :headers="requestHeaders"
                :auto-upload="true"
                :multiple="true"
              >
                <el-button slot="trigger" size="small" type="primary">上传文件</el-button>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="备注" prop="remark">
              <el-input type="textarea" :rows="4" v-model="form.remark"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveWorkdiary()">确 定</el-button>
      </div>
    </el-dialog>
    <el-image
      style="width: 0px; height: 0px"
      :src="url"
      :lazy="true"
      ref="preview"
      :preview-src-list="srcList">
    </el-image>
    <el-dialog title="物流信息" :visible.sync="isShow" @close="close" style="height:700px;">
      <el-timeline :reverse="reverse">
        <el-timeline-item
          v-for="(activity, index) in activities"
          :key="index"
          color= '#fe722c'
          :timestamp="activity.time">
          {{activity.status}}
        </el-timeline-item>
      </el-timeline>
    </el-dialog>
  </div>
</template>

<script>
import Top from '@/components/Member/Top'
import LeftNav from '@/components/Member/Left_nav'
import Bottom from '@/components/Member/Bottom'
import Pagination from '@/components/Pagination'
import { mapGetters } from 'vuex'
import api from '@/api/workdiary'
import busOrders from '@/api/businessOrders'
import { getType, getToken } from '@/utils/auth'
import apiConfig from '../../../config/api.config.js'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import vuelist from '@/utils/vue_list'

export default {
  name: 'Workdiary',
  components: { Top, LeftNav, Bottom, Pagination, ElImageViewer },
  mixins: [vuelist],
  data () {
    return {
      api,
      list: [],
      total: 0,
      upload_url: apiConfig.baseUrl + '/admin/Upload/Upload_workdiary',
      requestHeaders: {
        'X-Token': getToken()
      },
      url: '',
      showImagePreview: false,
      qyloading: false,
      srcList: [],
      fileList: [],
      listQuery: {
        limit: 10,
        page: 1,
        order: 'date_time',
        is_delete: 1
      },
      dialogFormVisible: false,
      locktype: false,
      form: {
        job_content: '',
        date_time: new Date(),
        remark: '',
        title: '',
        img: '',
        state: '0',
        expressage: '',
        tracking_number: '',
        tel: ''
      },
      rules: {
        job_content: [{ required: true, message: '请输入日志内容', trigger: 'blur' }],
        date_time: [{ required: true, message: '请选择日期', trigger: 'blur' }]
      },
      addtimeBTTime: [],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      gridData: ['德邦快递', '顺丰速运', '京东', '百世快递', '中通快递', '申通快递', '圆通速递', '韵达速递', '邮政快递包裹', 'EMS', '优速快递', '宅急送', '顺心捷达', '安能', '其他'],
      gridDatass:
      [{
        label: '德邦快递',
        value: 'DBL'
      }, {
        label: '顺丰速运',
        value: 'SF'
      }, {
        label: '京东',
        value: 'JD'
      }, {
        label: '百世快递',
        value: 'HTKY'
      }, {
        label: '中通快递',
        value: 'ZTO'
      }, {
        label: '申通快递',
        value: 'STO'
      }, {
        label: '圆通速递',
        value: 'YTO'
      }, {
        label: '韵达速递',
        value: 'YD'
      }, {
        label: '邮政快递包裹',
        value: 'YZPY'
      }, {
        label: 'EMS',
        value: 'EMS'
      }, {
        label: '天天快递',
        value: 'HHTT'
      }, {
        label: '优速快递',
        value: 'UC'
      }, {
        label: '宅急送',
        value: 'ZJS'
      }, {
        label: '顺心捷达',
        value: 'SXJD'
      }, {
        label: '安能',
        value: 'ANE'
      }, {
        label: '其他',
        value: 'qts'
      }],
      reverse: true,
      activities: [],
      isShow: false,
      optionsUserList: []
    }
  },
  computed: {
    ...mapGetters([ 'current_user' ])
  },
  mounted () {
    this.LoadData()
    this.getUserList()
  },
  methods: {
    Createtask () {
      this.dialogFormVisible = true
      this.form = {
        name: this.current_user.name,
        admin_id: this.current_user.id,
        job_content: '',
        date_time: new Date(),
        remark: '',
        title: '',
        img: '',
        state: '0',
        tracking_number: '',
        expressage: '',
        tel: ''
      }
      this.srcList = []
      this.fileList = []
    },
    saveWorkdiary () {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          if (this.form.expressage === '顺丰速运' && !this.form.tel) {
            this.$notify({
              title: '警告',
              message: '请输入收/寄件人手机号',
              type: 'warning'
            })
            return false
          }
          if (this.locktype) {
            return false
          }
          this.locktype = true
          this.form.voucher = this.fileList
          api.saveWorkdiary(this.form).then(response => {
            this.dialogFormVisible = false
            this.locktype = false
            this.LoadData()
            this.$notify({
              title: '成功',
              message: response.message,
              type: 'success'
            })
          })
        }
      })
    },
    handleEdit (index, row) {
      this.dialogFormVisible = true
      this.form = Object.assign({}, row)
      if (row.voucher) {
        this.fileList = row.voucher
      } else {
        this.fileList = []
      }
    },
    handlesuccess (response, file, fileList) {
      if (response.code === 20000) {
        this.fileList = fileList
      } else {
        this.$message.error(response.message)
      }
    },
    beforeAvatarUpload (file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = testmsg === 'xls'
      const extension2 = testmsg === 'xlsx'
      const extension3 = testmsg === 'docx'
      const extension4 = testmsg === 'doc'
      const extension5 = testmsg === 'jpg'
      const extension6 = testmsg === 'pdf'
      const extension7 = testmsg === 'png'
      const extension8 = testmsg === 'zip'
      const extension9 = testmsg === 'rar'
      const isLt2M = file.size / 1024 / 1024 < 10
      if (!extension && !extension2 && !extension3 && !extension4 && !extension5 && !extension6 && !extension7 && !extension8 && !extension9) {
        this.$message({
          message: '上传文件只能是 xls、xlsx、docx、doc、jpg、png、pdf、zip、rar格式!',
          type: 'warning'
        })
      }
      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 10MB!',
          type: 'warning'
        })
      }
      return (extension || extension2 || extension3 || extension4 || extension5 || extension6 || extension7 || !extension8 || !extension9) && isLt2M
    },
    removeUpload (file, fileList) {
      this.fileList = fileList
    },
    handleClick (row) {
      const thisType = getType(row.img)
      if (thisType === 'image') {
        this.srcList = [row.img]
        this.url = row.img
        this.$nextTick(() => {
          this.$refs.preview.clickHandler()
        })
      } else if (thisType === 'pdf') {
        window.open(row.img, '_target')
      } else {
        const url = 'http://view.officeapps.live.com/op/view.aspx?src=' + row.img
        window.open(url, '_target')
      }
    },
    // 关闭预览
    closePreview () {
      this.showImagePreview = false
      document.body.style.overflow = 'auto'
    },
    handleDelete (row, index, scopes) {
      api.handleDelete({ id: row.id }).then(response => {
        this.LoadData()
        scopes._self.$refs[`popover-${scopes.$index}`].doClose()
      })
    },
    operationManual () {
      this.$nextTick(() => {
        this.$refs.preview.clickHandler()
      })
    },
    selectOperationTime () {
      this.listQuery.page = 1
      if (this.addtimeBTTime) {
        this.listQuery.operationBTTime = this.addtimeBTTime
      } else {
        this.listQuery.operationBTTime = []
      }
      this.LoadData()
    },
    changeinvoice (row) {
      api.changeinvoice(row).then((response) => {
        this.$notify({ title: '成功', message: response.message, type: 'success', duration: 2000 })
      })
    },
    checkLogistics (row) {
      this.activities = []
      this.isShow = true
      api.checkLogistics({ com: row.expressagebh, nu: row.tracking_number, tel: row.tel }).then(res => {
        if (res.item.status === '0') {
          this.activities = res.item.result.list.reverse()
        } else {
          this.$message.error(res.item.msg)
        }
      })
    },
    close () {},
    getUserList () {
      busOrders.getUserList({MAccountRole: '1, 5'}).then(response => {
        this.optionsUserList = response.data
      })
    },
    dowloadFile (urlFile) {
      window.open(urlFile, '_blank')
    },
    dowloadFiless (urlFile) {
      window.open(urlFile.message, '_blank')
    }
  }
}
</script>
<style scoped>
.cght_subpagemaina{
  padding-top: 25px;
}
.cgw1216{
  width: 1445px;
}
.cght_htmainright{
  width: 85%;
}
.el-image >>> .el-image-viewer__close{
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/view/member/workdiary.vue